/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AccountConnectionStatusResponse
 */
export interface AccountConnectionStatusResponse {
    /**
     * Account connection status. SUCCESS when all connections are normal, EXPIRING when at least one token is expiring soon, EXPIRED when at least one token has expired, FAILURE when at least one account operation has failed, NOT_CONNECTED when no connection exists
     * @type {string}
     * @memberof AccountConnectionStatusResponse
     */
    'status': AccountConnectionStatusResponseStatusEnum;
}

export const AccountConnectionStatusResponseStatusEnum = {
    success: 'SUCCESS',
    failure: 'FAILURE',
    expiring: 'EXPIRING',
    expired: 'EXPIRED',
    notConnected: 'NOT_CONNECTED'
} as const;

export type AccountConnectionStatusResponseStatusEnum = typeof AccountConnectionStatusResponseStatusEnum[keyof typeof AccountConnectionStatusResponseStatusEnum];


